
import { hollyBio, luigiBio, frodoBio } from './gatsbyBios'
import { hollyReviewerReviewHinge, luigiReviewerReviewBumble, frodoReviewerReviewTinder } from './gatsbyReviewerReviews'

export const hollyReviewerProfile = {
  _id: 'hollyReviewerProfileId',
  userId: 'hollyUserId',
  email: 'holly@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-holly-12-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...hollyBio },
  profileReviews: [
    // { ...hollyProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...hollyReviewerReviewHinge }
  ],
}

export const luigiReviewerProfile = {
  _id: 'luigiReviewerProfileId',
  userId: 'luigiUserId',
  email: 'luigi@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-luigi-13-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...luigiBio },
  profileReviews: [
    // { ...luigiProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...luigiReviewerReviewBumble }
  ],
}

export const frodoReviewerProfile = {
  _id: 'frodoReviewerProfileId',
  userId: 'frodoUserId',
  email: 'frodo@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-frodo-8-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...frodoBio },
  profileReviews: [
    // { ...frodoProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...frodoReviewerReviewTinder }
  ],
}